<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="6">
          <el-menu
            class="el-menu-vertical-demo">
            <el-menu-item index="2">
              <span slot="title">导航二</span>
            </el-menu-item>
          </el-menu>

      </el-col>
      <el-col :span="18">
        <router-view></router-view>
      </el-col>
    </el-row>
  </div>

</template>
<script>
export default {
    data() {
        return {
        }
    },
    created: function() {
      console.log('created');
    },
    methods: {

    }
}
</script>
<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// lrLayout.vue?47c9ecee